import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircle, XCircle } from 'lucide-react';
export function PainSection() {
  const painPoints = ['cálmate', 'come', 'espera', 'no pelees', 'déjame trabajar', 'por favor… dame 10 minutos'];
  const failedSolutions = [{
    title: '“Ok, pero solo 5 minutos más”',
    result: '(y se vuelve 15… y luego 30)'
  }, {
    title: '“Se acabó, nunca más”',
    result: '(y mañana vuelves porque no hay plan)'
  }, {
    title: '“Te lo expliqué mil veces”',
    result: '(y el niño no puede usar lógica cuando está activado)'
  }];
  return <section className="w-full bg-[#F5EDE3] px-4 py-16 md:py-24" data-id="element-114">
      <div className="max-w-3xl mx-auto" data-id="element-115">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-116">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1B2A4A] mb-8 font-serif text-center" data-id="element-117">
            El problema real no es “demasiada pantalla”
          </h2>

          <p className="text-lg text-[#4A5568] mb-6" data-id="element-118">
            Es que, sin darte cuenta, la pantalla se convirtió en el botón de:
          </p>

          <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mb-10" data-id="element-119">
            {painPoints.map((point, index) => <div key={index} className="bg-white p-4 rounded-lg shadow-sm border border-[#E2E8F0] text-center text-[#1B2A4A] font-medium" data-id="element-120">
                {point}
              </div>)}
          </div>

          <div className="bg-[#FDF8F0] p-6 md:p-8 rounded-xl border-l-4 border-[#C4704B] mb-12" data-id="element-121">
            <p className="text-xl text-[#1B2A4A] italic" data-id="element-122">
              "Y no porque seas flojo/a. Porque estás cansado/a. Porque estás
              solo/a. Porque nadie te enseñó qué hacer cuando el niño explota al
              apagar."
            </p>
          </div>

          <h3 className="text-2xl font-bold text-[#1B2A4A] mb-6 font-serif" data-id="element-123">
            Entonces intentas lo típico:
          </h3>

          <div className="space-y-4 mb-10" data-id="element-124">
            {failedSolutions.map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="flex items-start bg-white p-4 rounded-lg shadow-sm" data-id="element-125">
                <XCircle className="h-6 w-6 text-[#C53030] mt-1 mr-3 flex-shrink-0" data-id="element-126" />
                <div data-id="element-127">
                  <p className="font-bold text-[#1B2A4A]" data-id="element-128">{item.title}</p>
                  <p className="text-[#4A5568]" data-id="element-129">{item.result}</p>
                </div>
              </motion.div>)}
          </div>

          <div className="text-center" data-id="element-130">
            <p className="text-xl font-medium text-[#1B2A4A] bg-[#C4704B]/10 inline-block px-6 py-3 rounded-lg" data-id="element-131">
              Resultado: la casa gira alrededor del apagado.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}